import React, { useState } from "react"
import { useLoading } from "helpers/custom_hooks"
import { UpdateRepairRequest } from "helpers/backend_helper"
import { displayMessage } from "helpers/misc_helpers"
import moment from "moment"
import DeclineRepairOfferModal from "components/Common/DeclineRepairOfferModal"
import { Link } from "react-router-dom"

const RepairAcceptOfferListItem = ({ entry, myUser, statusIndex, reload }) => {
  const setLoading = useLoading()
  const [declineRepairOfferModal, setDeclineRepairOfferModal] = useState(false)
  const [agbAccepted, setAgbAccepted] = useState(false)

  const hasAGB = () => !!(entry?.agbFileURL || entry?.agbLink)

  const handleAcceptOffer = async () => {
    setLoading(true)
    try {
      if (isUserRequestor()) {
        entry.dateOfferAcceptedRequestor = new Date()
        if (hasAGB()) entry.dateAgbAcceptedRequestor = new Date()
      }

      entry.statusIndex++

      await UpdateRepairRequest(entry)
      reload()
    } catch (error) {
      error?.response?.status == 400
        ? displayMessage(error.response.data, setError)
        : displayMessage("An unexpected error happened!", setError)
      console.log(error)
    }
  }

  const getAcceptedDate = () => {
    return moment(entry.dateOfferAcceptedRequestor).format("DD.MM.YYYY")
  }

  const isUserRequestor = () => myUser?.company?.id == entry?.requestorCompanyID

  return (
    <>
      {entry?.dateOfferAcceptedRequestor ? (
        <li
          className={
            "event-list " + (entry?.statusIndex == statusIndex ? "active" : "")
          }
        >
          <div
            className={
              "event-timeline-dot " +
              (entry?.statusIndex == statusIndex ? "bx-fade-right" : "")
            }
          >
            <i className="bx bx-right-arrow-circle font-size-18"></i>
          </div>
          <div className="d-flex">
            <div className="flex-shrink-0 me-3">
              <h5 className="font-size-14">
                {getAcceptedDate()}
                <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
            </div>
            <div className="flex-grow-1">
              <div>Offer accepted</div>
            </div>
          </div>
        </li>
      ) : (
        <>
          {entry?.statusIndex == statusIndex - 1 && isUserRequestor() && (
            <>
              <p className="ms-3">
                <strong>
                  You have received the quotation for the chosen Repair
                  inspection. Please confirm to initialize the further process.
                </strong>
              </p>

              {hasAGB() && (
                <div className="form-check ms-3 mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="agbAcceptCheckbox"
                    checked={agbAccepted}
                    onChange={e => setAgbAccepted(e.target.checked)}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="agbAcceptCheckbox"
                  >
                    I accept the{" "}
                    <a
                      href={entry?.agbFileURL ?? entry?.agbLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      terms & conditions
                    </a>{" "}
                    of the repair lab
                  </label>
                </div>
              )}

              <button
                type="button"
                onClick={handleAcceptOffer}
                disabled={hasAGB() && !agbAccepted}
                className="btn btn-primary ms-3"
              >
                Accept
              </button>
              <button
                type="button"
                onClick={_ => setDeclineRepairOfferModal(true)}
                className="btn btn-danger ms-3"
              >
                Decline
              </button>
              {/* {isUserRequestor() && (
                <Link
                  type="button"
                  to={"/repair-request-wizard?id=" + entry?.id}
                  className="btn btn-warning ms-3"
                >
                  Edit request
                </Link>
              )} */}
            </>
          )}
        </>
      )}
      <DeclineRepairOfferModal
        entry={entry}
        show={declineRepairOfferModal}
        toggle={_ => setDeclineRepairOfferModal(false)}
        myUser={myUser}
        reload={reload}
      />
    </>
  )
}

export default RepairAcceptOfferListItem
